<template>
    <div class="stepper">
        <!-- <transition-group  tag="p"> -->
        <div v-for="step in steps" :key="step">
            <transition :name="transition">
                <div v-show="value === step">
                    <slot :name="step"/>
                </div>
            </transition>
        </div>
        <!-- </transition-group> -->
    </div>
</template>

<script>
    export default {
        watch: {
            value (val, old) {
                this.transition = val - old > 0 ? 'foward' : 'backwards'
            }
        },
        props: {
            value: {
                type: Number,
                default: 0
            },
            steps: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                transition: 'foward'
            }
        },
    }
</script>

<style scoped>
.stepper {
    position: relative;
    overflow-x: hidden;
    width: 100%;
}
.foward-leave-active, .backwards-leave-active {
  position: absolute;
}
.foward-enter-active, .foward-leave-active, .backwards-enter-active, .backwards-leave-active  {
  transition: all 0.5s;
}
.foward-enter, .backwards-leave-to {
  opacity: 0;
  transform: translateX(100%);
}
.foward-leave-to, .backwards-enter {
  opacity: 0;
  transform: translateX(-100%);
}
</style>